import { Locales } from '@carsys/enums/locales'
import { APIResponse, DELETEResponse, GETResponse, POSTRequestBody, PUTRequestBody, PaginatedResponse } from '@cbgms/api'

export enum ShopModule {
  GarageAdmin = 'GA',
  Portal = 'portal',
  GMS = 'GMS'
}

export enum MessageTemplate {
  Default = 'default',
  BankHoliday = 'bank-holiday'
}

export enum StatusType {
  Read = 'read',
  Removed = 'deleted',
  Unread = 'unread'
}

export interface IMessage {
  EndDate: string
  Message: string
  PublishDate: string
  Title: string
  ShopIDs: string | string[]
  Template: MessageTemplate
  UUID: string
  Status: StatusType
  LocalizedMessages: LocalizedMessage[]
}
export interface LocalizedMessage {
  Locale: Locales
  Message: string
  Title: string
}
export interface ISupportMessage {
  EndDate: string
  Message: string
  PublishDate: string
  ShopIDs: string | string[]
  Title: string
  Template: MessageTemplate
  UUID: string
  TargetedModules: ShopModule[]
  LocalizedMessages: LocalizedMessage[]
}

export interface IMessageBody {
  Status: StatusType
}

export type DELETETMessageResponse = DELETEResponse

export type GETSupportMessageResponse = GETResponse<ISupportMessage>

export type GETMessagesResponse = PaginatedResponse<GETMessagesResponseRow>

export interface GETMessagesResponseRow {
  SystemMessage: IMessage
}

export type POSTMessageBody = POSTRequestBody<ISupportMessage, 'PublishDate' | 'Title' | 'Template'>

export type POSTMessageResponse = APIResponse<{ UUID: string }>

export type PUTMessageBody = PUTRequestBody<ISupportMessage>

export type PUTMessageResponse = APIResponse<{ UUID: string }>

export type GETFilteredMessagesResponse = PaginatedResponse<IMessage>
export type PUTMessageStatusBody = PUTRequestBody<IMessageBody>

export const isIMessage = (item: unknown): item is IMessage => {
  return (
    typeof item === 'object' &&
    item !== null &&
    'EndDate' in item &&
    'Message' in item &&
    'PublishDate' in item &&
    'ShopIDs' in item &&
    'Title' in item &&
    'Template' in item &&
    'UUID' in item &&
    'Status' in item &&
    'LocalizedMessages' in item &&
    Array.isArray((item as IMessage).LocalizedMessages)
  )
}
